import { render, staticRenderFns } from "./HospitalAssetManagementTemplate.vue?vue&type=template&id=c5a3978c&scoped=true"
import script from "./HospitalAssetManagementTemplate.vue?vue&type=script&lang=js"
export * from "./HospitalAssetManagementTemplate.vue?vue&type=script&lang=js"
import style0 from "./HospitalAssetManagementTemplate.vue?vue&type=style&index=0&id=c5a3978c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5a3978c",
  null
  
)

export default component.exports